export default __webpack_public_path__ + "static/B0304-f38ca194d4611940bc9fb10bd76c1f4d.png";